// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"3fba5efd","678":"b915e89f","997":"f9e77774"}[chunkId] + ".chunk.css";
};